// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table-header th.sortable{padding-top:12px!important}.v-data-table table tbody tr td{padding-top:14px!important;color:#6c757d!important;cursor:pointer;font-size:.85rem!important}.row-v-data-table{padding-bottom:2rem!important}.v-data-table>.v-data-table__wrapper>table>thead>tr>th{padding-top:8px!important}.v-main__wrap{background-color:#fafafa}", ""]);
// Exports
module.exports = exports;
